import React from 'react';
import { string, oneOfType } from 'prop-types';
import { pathOr } from 'ramda';
import { FormattedMessage, injectIntl } from 'react-intl';
import moment from 'moment';
import classNames from 'classnames';

import { isSeasonalMarketplace, seasonEnd, seasonStart } from '../../marketplace-custom-config';
import { AvatarMedium, NamedLink, ExpandableText } from '../../components';
import { ensureUser, ensureCurrentUser } from '../../util/data';
import { propTypes } from '../../util/types';
import css from './UserCard.css';

const BIO_MAX_LENGTH_DESKTOP = 180;
const BIO_MAX_LENGTH_MOBILE = 110;

const UserCard = props => {
  const { rootClassName, className, user, currentUser } = props;

  const userIsCurrentUser = user && user.type === 'currentUser';
  const ensuredUser = userIsCurrentUser ? ensureCurrentUser(user) : ensureUser(user);
  const ensuredCurrentUser = ensureCurrentUser(currentUser);
  const isCurrentUser =
    ensuredUser.id && ensuredCurrentUser.id && ensuredUser.id.uuid === ensuredCurrentUser.id.uuid;
  const { createdAt, profile } = ensuredUser.attributes;
  const { bio, displayName, publicData } = profile;
  const hasResponseInfos = pathOr(null, ['responseInfos'], publicData);
  const responseRate = pathOr(null, ['responseInfos', 'responseRate'], publicData);
  const currentMonth = moment().month();
  const currentYear = moment().year();
  const lastUpdated = pathOr(null, ['responseInfos', 'lastUpdated'], publicData);
  const lastUpdatedYear = moment(lastUpdated).year();
  const hasResponseRate = responseRate && ((isSeasonalMarketplace && currentYear === lastUpdatedYear) || !isSeasonalMarketplace)
  const responseRateFormatted = hasResponseRate ?
    <FormattedMessage id="UserCard.responseRate" values={{ responseRate }} /> :
    <FormattedMessage id="UserCard.noResponseRate" />;
  const showReponseInfos = false;
  const hasBio = !!bio;
  const classes = classNames(rootClassName || css.root, className);
  const linkClasses = classNames(css.links, {
    [css.withBioMissingAbove]: !hasBio,
  });
  const separator = isCurrentUser && <span className={css.linkSeparator}>•</span>;
  const editProfile = (
      <NamedLink name="ProfileSettingsPage">
        <FormattedMessage id="UserCard.editProfileLink" />
      </NamedLink>
  );
  const links = ensuredUser.id && (
    <p className={linkClasses}>
      <NamedLink className={css.link} name="ProfilePage" params={{ id: ensuredUser.id.uuid }}>
        <FormattedMessage id="UserCard.viewProfileLink" />
      </NamedLink>
      {isCurrentUser && separator}
      {isCurrentUser && editProfile}
    </p>
  );

  return (
    <div className={classes}>
      <div className={css.headingContainer}>
        <AvatarMedium className={css.avatar} user={user} />
        <div className={css.infoContainer}>
          <h2 className={css.heading}>
            <FormattedMessage id="UserCard.heading" values={{ name: displayName }} />
          </h2>
          <div className={css.createdAt}>
            <FormattedMessage id="UserCard.createdAt" values={{ createdAt: moment(createdAt).year() }} />
          </div>
        </div>
      </div>
      <div className={css.contentContainer}>
        <div className={css.mainContent}>
          {hasBio && <ExpandableText className={css.desktopBio} text={bio} length={BIO_MAX_LENGTH_DESKTOP} />}
          {hasBio && <ExpandableText className={css.mobileBio} text={bio} length={BIO_MAX_LENGTH_MOBILE} />}
          {links}
        </div>
        <div className={css.mainContent}>
          {showReponseInfos &&
            <div className={css.responseContainer}>
            <div className={css.responseInfos}>
              {responseRateFormatted}
            </div>
            {isSeasonalMarketplace && 
              <p className={css.responseInfosNote}>
                <FormattedMessage
                  id="UserCard.responseInfosNote"
                  values={{
                    seasonStartMonth: seasonStart.month,
                    seasonEndMonth: seasonEnd.month,
                  }}
                />
              </p>
            }
          </div>}
        </div>
      </div>
    </div>
  );
};

UserCard.defaultProps = {
  rootClassName: null,
  className: null,
  user: null,
  currentUser: null,
};

UserCard.propTypes = {
  rootClassName: string,
  className: string,
  user: oneOfType([propTypes.user, propTypes.currentUser]),
  currentUser: propTypes.currentUser,
};

export default injectIntl(UserCard);



// WEBPACK FOOTER //
// ./src/components/UserCard/UserCard.js